module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/ipadpro3_splash-3840f81dbe7c805aa1288538f9f77397.png";